/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    string,
} from 'prop-types';

const DropDownIcon = ({
    fillColor,
}) => (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5.83333 4.65482L10.2441 0.244078C10.5695 -0.0813592 11.0972 -0.0813592 11.4226 0.244078C11.748 0.569515 11.748 1.09715 11.4226 1.42259L6.42259 6.42259C6.09715 6.74803 5.56951 6.74803 5.24408 6.42259L0.244078 1.42259C-0.0813593 1.09715 -0.0813593 0.569515 0.244078 0.244078Z" fill={fillColor} />
    </svg>

);

DropDownIcon.propTypes = {
    fillColor: string,
};

DropDownIcon.defaultProps = {
    fillColor: '#2F2F2F',
};

export default DropDownIcon;
